import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NeighborhoodInsight } from '../interface/neighborhood.interface';

@Injectable({
  providedIn: 'root',
})
export class NeighborhoodState {
  constructor() {}

  /** Stores Zip-Code and Comparable insights */
  private _insightSub$ = new BehaviorSubject<NeighborhoodInsight | null>(null);
  insight$ = this._insightSub$.asObservable();

  /** Tracks whether a neighborhood analysis fetch is currently running, so pages can show an inline loader */
  private _loadingSub$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSub$.asObservable();

  /** The config-driven locality page layout, or null when the company has none. */

  get insight(): NeighborhoodInsight | null {
    return this._insightSub$.value;
  }

  set insight(data: NeighborhoodInsight | null) {
    this._insightSub$.next(data);
  }

  get loading(): boolean {
    return this._loadingSub$.value;
  }

  set loading(value: boolean) {
    this._loadingSub$.next(value);
  }
}
